// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:wght@400;500&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: center;
  min-height:100vh;
  margin:0;
  padding:0;
  max-width: 100vw;
  display: block;
  /*overflow-y: hidden;*/
}
html,
body {
  margin: 0;
  padding: 0;
  overflow-x: hidden;
}

@media (prefers-color-scheme: dark) {
  #app,html,body{
    background: #252525;
  }
}
@media (prefers-color-scheme: no-preference) {
  #app,html,body{
    background: #f5f5f5;
  }
}
@media (prefers-color-scheme: light) {
  #app,html,body{
    background: #f5f5f5;
  }
}
/*@media (prefers-color-scheme: dark) {*/
/*  .Md-Sidebar-Computer{*/
/*    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2)*/
/*  }*/
/*}*/


.MuiPaper-rounded, .MuiInputBase-root,  .MuiButtonBase-root{
  border-radius: 20px !important;
}
.Md-InputSearch {
  border-radius: 20px !important;
}
.MuiButton-root {
  border-radius: 10px !important;
}

.Md-Button-color {
  color: #FF7233 !important;
}
.Md-Button-color:hover {
  background: rgba(255,114,51,0.05) !important;
}
.Md-Button-Add {
  color: #FF7233 !important;
  border: 1px solid #FF7233 !important;
}
.Md-Button-Add:hover {
  background: rgba(255,114,51,0.05) !important;
}

/*#######################################*/
.Md-Sidebar-Computer {
  height: 95vh;
  margin-left:15px;
  margin-top:15px;
  position:fixed;
  white-space: nowrap;
  box-sizing: border-box;
}

.Md-Sidebar-mobile {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left:15px;
  margin-top:15px;
  height: 40px;
  width: 40px;
  position:fixed;
  white-space: nowrap;
  box-sizing: border-box;
  border-radius: 20px;
}

.Md-Sidebar-Computer.activated {
  animation: Md-Sidebar-Computer-activated 300ms forwards;
}

.Md-Sidebar-Computer.disactivated {
  animation: Md-Sidebar-Computer-disactivated 1s forwards;
}

@keyframes Md-Sidebar-Computer-activated{
  0% {
    width: 65px;
  }
  100% {
    width: 275px;
  }
}

@keyframes Md-Sidebar-Computer-disactivated{
  0% {
    width: 275px;
  }
  100% {
    width: 65px;
  }
}


/*#######################################*/
#Md-Container {
  display: flex;
  /*height: calc(100vh - 30px);*/
  min-height: calc(100vh - 30px);
  width: 100%;
}


#Md-Container.mobile {
  margin-left:5%;
  padding: 15px 15px 15px 0;
}

#Md-Container.activated {

  animation: Md-Container-activated 300ms forwards;
}

#Md-Container.disactivated {
  animation: Md-Container-disactivated 1s forwards;
}

@keyframes Md-Container-activated{
  0% {
    padding-left: 115px;
  }
  100% {
    padding-left: 300px;
  }
}
@keyframes Md-Container-disactivated{
  0% {
    padding-left: 300px;
  }
  100% {
    padding-left: 115px;
  }
}

/*#######################################*/


.waves{
  position:fixed;
  /*width: 100%;*/
  width: 100vw;
  /*height:10vh;*/
  /*min-height:100px;*/
  height:150px;
  bottom:0;
  left:0;
}

/* Animation */
.parallax > use {
  animation: move-forever 25s cubic-bezier(.5,.5,.45,.5)     infinite;
}
.parallax > use:nth-child(1) {
  animation-delay: -2s;
  animation-duration: 20s;
}
.parallax > use:nth-child(2) {
  animation-delay: -3s;
  animation-duration: 23s;
}
.parallax > use:nth-child(3) {
  animation-delay: -4s;
  animation-duration: 26s;
}
.parallax > use:nth-child(4) {
  animation-delay: -5s;
  animation-duration: 29s;
}

@keyframes move-forever {
  0% {
    transform: translate3d(85px,0,0);
  }
  100% {
    transform: translate3d(-90px,0,0);
  }
}
/*Shrinking for mobile*/
@media (max-width: 1000px) {
  .waves {
    /*height:40px;*/
    width: 200vw;
    /*min-height:40px;*/
  }
}
/*Shrinking for mobile*/
@media (max-width: 500px) {
  .waves {
    /*height:40px;*/
    width: 400vw;
    /*min-height:40px;*/
  }
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,QAAQ;EACR,SAAS;EACT,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;AACA;;EAEE,SAAS;EACT,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE;IACE,mBAAmB;EACrB;AACF;AACA;EACE;IACE,mBAAmB;EACrB;AACF;AACA;EACE;IACE,mBAAmB;EACrB;AACF;AACA,wCAAwC;AACxC,0BAA0B;AAC1B,iDAAiD;AACjD,MAAM;AACN,IAAI;;;AAGJ;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,4CAA4C;AAC9C;AACA;EACE,yBAAyB;EACzB,oCAAoC;AACtC;AACA;EACE,4CAA4C;AAC9C;;AAEA,0CAA0C;AAC1C;EACE,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,WAAW;EACX,cAAc;EACd,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,uDAAuD;AACzD;;AAEA;EACE,uDAAuD;AACzD;;AAEA;EACE;IACE,WAAW;EACb;EACA;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,YAAY;EACd;EACA;IACE,WAAW;EACb;AACF;;;AAGA,0CAA0C;AAC1C;EACE,aAAa;EACb,8BAA8B;EAC9B,8BAA8B;EAC9B,WAAW;AACb;;;AAGA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;;EAEE,gDAAgD;AAClD;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;AACF;AACA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;AACF;;AAEA,0CAA0C;;;AAG1C;EACE,cAAc;EACd,eAAe;EACf,YAAY;EACZ,eAAe;EACf,oBAAoB;EACpB,YAAY;EACZ,QAAQ;EACR,MAAM;AACR;;AAEA,cAAc;AACd;EACE,mEAAmE;AACrE;AACA;EACE,oBAAoB;EACpB,uBAAuB;AACzB;AACA;EACE,oBAAoB;EACpB,uBAAuB;AACzB;AACA;EACE,oBAAoB;EACpB,uBAAuB;AACzB;AACA;EACE,oBAAoB;EACpB,uBAAuB;AACzB;;AAEA;EACE;IACE,gCAAgC;EAClC;EACA;IACE,iCAAiC;EACnC;AACF;AACA,uBAAuB;AACvB;EACE;IACE,eAAe;IACf,YAAY;IACZ,mBAAmB;EACrB;AACF;AACA,uBAAuB;AACvB;EACE;IACE,eAAe;IACf,YAAY;IACZ,mBAAmB;EACrB;AACF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@400;500&display=swap');\n\n.App {\n  text-align: center;\n  min-height:100vh;\n  margin:0;\n  padding:0;\n  max-width: 100vw;\n  display: block;\n  /*overflow-y: hidden;*/\n}\nhtml,\nbody {\n  margin: 0;\n  padding: 0;\n  overflow-x: hidden;\n}\n\n@media (prefers-color-scheme: dark) {\n  #app,html,body{\n    background: #252525;\n  }\n}\n@media (prefers-color-scheme: no-preference) {\n  #app,html,body{\n    background: #f5f5f5;\n  }\n}\n@media (prefers-color-scheme: light) {\n  #app,html,body{\n    background: #f5f5f5;\n  }\n}\n/*@media (prefers-color-scheme: dark) {*/\n/*  .Md-Sidebar-Computer{*/\n/*    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2)*/\n/*  }*/\n/*}*/\n\n\n.MuiPaper-rounded, .MuiInputBase-root,  .MuiButtonBase-root{\n  border-radius: 20px !important;\n}\n.Md-InputSearch {\n  border-radius: 20px !important;\n}\n.MuiButton-root {\n  border-radius: 10px !important;\n}\n\n.Md-Button-color {\n  color: #FF7233 !important;\n}\n.Md-Button-color:hover {\n  background: rgba(255,114,51,0.05) !important;\n}\n.Md-Button-Add {\n  color: #FF7233 !important;\n  border: 1px solid #FF7233 !important;\n}\n.Md-Button-Add:hover {\n  background: rgba(255,114,51,0.05) !important;\n}\n\n/*#######################################*/\n.Md-Sidebar-Computer {\n  height: 95vh;\n  margin-left:15px;\n  margin-top:15px;\n  position:fixed;\n  white-space: nowrap;\n  box-sizing: border-box;\n}\n\n.Md-Sidebar-mobile {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-left:15px;\n  margin-top:15px;\n  height: 40px;\n  width: 40px;\n  position:fixed;\n  white-space: nowrap;\n  box-sizing: border-box;\n  border-radius: 20px;\n}\n\n.Md-Sidebar-Computer.activated {\n  animation: Md-Sidebar-Computer-activated 300ms forwards;\n}\n\n.Md-Sidebar-Computer.disactivated {\n  animation: Md-Sidebar-Computer-disactivated 1s forwards;\n}\n\n@keyframes Md-Sidebar-Computer-activated{\n  0% {\n    width: 65px;\n  }\n  100% {\n    width: 275px;\n  }\n}\n\n@keyframes Md-Sidebar-Computer-disactivated{\n  0% {\n    width: 275px;\n  }\n  100% {\n    width: 65px;\n  }\n}\n\n\n/*#######################################*/\n#Md-Container {\n  display: flex;\n  /*height: calc(100vh - 30px);*/\n  min-height: calc(100vh - 30px);\n  width: 100%;\n}\n\n\n#Md-Container.mobile {\n  margin-left:5%;\n  padding: 15px 15px 15px 0;\n}\n\n#Md-Container.activated {\n\n  animation: Md-Container-activated 300ms forwards;\n}\n\n#Md-Container.disactivated {\n  animation: Md-Container-disactivated 1s forwards;\n}\n\n@keyframes Md-Container-activated{\n  0% {\n    padding-left: 115px;\n  }\n  100% {\n    padding-left: 300px;\n  }\n}\n@keyframes Md-Container-disactivated{\n  0% {\n    padding-left: 300px;\n  }\n  100% {\n    padding-left: 115px;\n  }\n}\n\n/*#######################################*/\n\n\n.waves{\n  position:fixed;\n  /*width: 100%;*/\n  width: 100vw;\n  /*height:10vh;*/\n  /*min-height:100px;*/\n  height:150px;\n  bottom:0;\n  left:0;\n}\n\n/* Animation */\n.parallax > use {\n  animation: move-forever 25s cubic-bezier(.5,.5,.45,.5)     infinite;\n}\n.parallax > use:nth-child(1) {\n  animation-delay: -2s;\n  animation-duration: 20s;\n}\n.parallax > use:nth-child(2) {\n  animation-delay: -3s;\n  animation-duration: 23s;\n}\n.parallax > use:nth-child(3) {\n  animation-delay: -4s;\n  animation-duration: 26s;\n}\n.parallax > use:nth-child(4) {\n  animation-delay: -5s;\n  animation-duration: 29s;\n}\n\n@keyframes move-forever {\n  0% {\n    transform: translate3d(85px,0,0);\n  }\n  100% {\n    transform: translate3d(-90px,0,0);\n  }\n}\n/*Shrinking for mobile*/\n@media (max-width: 1000px) {\n  .waves {\n    /*height:40px;*/\n    width: 200vw;\n    /*min-height:40px;*/\n  }\n}\n/*Shrinking for mobile*/\n@media (max-width: 500px) {\n  .waves {\n    /*height:40px;*/\n    width: 400vw;\n    /*min-height:40px;*/\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
